export default __webpack_public_path__ + "static/media/nature.4d2db30f.jpg";